import { BadgeTokens } from './types';

export const badge: BadgeTokens = {
  css: {
    color: 'neutral.0',
    bg: 'blue.50',
    mr: '-16px', // TODO: try to use the space tokens defined in figma
    p: '1px 0 0', // TODO: try to use the space tokens defined in figma
    transform: 'translate(-50%, -50%)', // TODO: try to use tokens defined in figma
  },
};
